export enum SignInProcessActionTypes {
  SendVerificationCode = 'signInProcess/sendVerificationCode',
  VerifyCode = 'signInProcess/verifyCode',
  VerifySession = 'signInProcess/verifySession',
  SignOut = 'signInProcess/signOut',
}
